import Modal from '@/components/v2/common/Modal';
import Content from './Content';
import Header from './Header';
import { SellerDetailsModalProps } from './types';

const SellerModal = ({ showModal, setShowModal }: SellerDetailsModalProps) => (
  <Modal
    isOpen={showModal}
    onClose={() => setShowModal(false)}
    width="max-w-[600px]"
  >
    <Header setShowModal={setShowModal} />
    <Content />
  </Modal>
);

export default SellerModal;
